import { defineComponent, Types } from "bitecs";

export const AnimationComponent = defineComponent({
    key: Types.f32,
    dirty: Types.i8,
    timeScale: Types.f32,
});
